// extracted by mini-css-extract-plugin
module.exports = {"theoryModal":"TheoryModal_theoryModal__3ZnX0"};